import { render, staticRenderFns } from "./PaginaAdminAprobacionRespuestas.vue?vue&type=template&id=36cb1d94&lang=true"
import script from "./PaginaAdminAprobacionRespuestas.vue?vue&type=script&lang=js"
export * from "./PaginaAdminAprobacionRespuestas.vue?vue&type=script&lang=js"
import style0 from "./PaginaAdminAprobacionRespuestas.vue?vue&type=style&index=0&id=36cb1d94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports